export default __webpack_public_path__ + "img/t2.b3eb5206.png";